module.exports = __webpack_public_path__ + "static/media/Chair2_Before.f6da9a1c.jpg";